// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__kZars","actions":"GroupTable_actions__Ft-E1","deleteModalFooter":"GroupTable_deleteModalFooter__3zgOH"};